import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import "./ThankYou.css";
import thank_you_message from "../Assets/ThankYou_Page/was_the_game_fun.png";
import Feedback from '../components/feedback_modal';
import congrats_audio from "../Assets/ThankYou_Page/starting_audio.mp3"
import Confetti from 'react-confetti'
import ThankYou_audio from "../Assets/ThankYou_Page/modal_audio.mp3";
import testData from "../Viscat-test-data.json";
import { testToolsEnabled } from '../testTools';

const { backEndBaseURL } = require('../config');

// VISCAT-386 - the scored levels in order, so a run that ended early still lists
// every level rather than only the ones it reached.
const SCORED_LEVELS = testData.levels
  .filter((level) => level['mode'] !== 'practice')
  .map((level) => level['level']);

const ThankYou = () => {
  const location = useLocation();
  // Absent state (production configuration, a testUID run, or a refresh) renders
  // the page exactly as it was before VISCAT-386.
  const demoSummary = testToolsEnabled() ? location.state : null;
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const audioRef = useRef(new Audio(congrats_audio));
  /** Survey-button clip; must be paused on unmount (orphaned `Audio` keeps playing). */
  const feedbackClipRef = useRef(null);
  // eslint-disable-next-line no-unused-vars
  const [testUID, setTestUID] = useState(localStorage.getItem("testUID"));

  useEffect(() => {
    const audio = audioRef.current;
    audio.load();
    audio.play()
      .catch(error => console.error("Failed to play the audio:", error));
    return () => {
      audio.pause();
      audio.currentTime = 0;
      const fb = feedbackClipRef.current;
      if (fb) {
        fb.pause();
        fb.currentTime = 0;
      }
    };
  }, []);

  /*
    Function requests to post users' survey results  to database, fundamental to testing.
    Currently opperates to take no paramaters working with the local storage of testUID. 
    last edited: 07/08/2024
  */
  async function postSurvey(surveyResult) {
    // Checks local storage testUID, if exists proceeds to try and post data
    if (testUID) {
      try {
        // console.log('sending data', JSON.stringify(tr,null,2));
        console.log(`${backEndBaseURL}/v2/candidateTest/${testUID}`);
        const result = await fetch(`${backEndBaseURL}/v2/candidateTest/${testUID}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            "level": "Survey",
            "survey": surveyResult
          })

        });
        console.log(result);
        // Check if response status is invalid 
        if (!result.ok) {
          console.error(`HTTP error! status: ${result.status}`);
          throw new Error(`HTTP error! status: ${result.status}`);
        }
        else {
          return new Promise(function (resolve, reject) {
            resolve(result);
          });
        }
      } catch (error) {
        console.error(error);
      }
    }
    return;
  }

  const handleFeedbackButton = (event) => {
    const congrats = audioRef.current;
    congrats.pause();
    congrats.currentTime = 0;

    setShowFeedbackModal(true);
    postSurvey(event.currentTarget.className);

    if (!feedbackClipRef.current) {
      feedbackClipRef.current = new Audio(ThankYou_audio);
    }
    const fb = feedbackClipRef.current;
    fb.pause();
    fb.currentTime = 0;
    fb.play().catch((err) => console.error('Error playing feedback audio:', err));
  };

  const playFeedbackMessage = () => {
    const audio = audioRef.current;
    if (audio.paused) {
      audio.play().catch(err => console.error("Error playing the audio:", err));
    } else {
      audio.pause();
    }
  };

  return (
    <div className='ThankYou_background'>
      <Confetti />
      <Feedback show={showFeedbackModal} showHomeButton={testUID === null} />

      <div className="Well_Done">Congratulations!</div>
      <img src={thank_you_message} alt="Thank You Message" className='thank_you_message' onClick={playFeedbackMessage} />

      <div className='feedback_buttons'>
        <button onClick={handleFeedbackButton} className='happy'></button>
        <button onClick={handleFeedbackButton} className='satisfied'></button>
        <button onClick={handleFeedbackButton} className='sad'></button>
      </div>

      {demoSummary && Array.isArray(demoSummary.scores) && (
        <div className='demo_score_panel'>
          <div className='demo_score_total'>
            {demoSummary.scores.reduce((sum, row) => sum + row.score, 0)} / {demoSummary.maxScore}
          </div>
          <ul className='demo_score_rows'>
            {SCORED_LEVELS.map((levelName) => {
              const row = demoSummary.scores.find((r) => r.level === levelName);
              return (
                <li key={levelName} className='demo_score_row'>
                  <span className='demo_score_level'>{levelName}</span>
                  <span className='demo_score_value'>
                    {row ? row.score : '— not reached'}
                  </span>
                </li>
              );
            })}
          </ul>
        </div>
      )}

    </div>
  );
}

export default ThankYou;